import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu } from 'antd';

interface MenuItemProps {
  to: string;
  label: string | React.ReactNode;
  onClick?: (e: React.MouseEvent<HTMLAnchorElement>, to: string) => void;
}

const MenuItem: React.FC<MenuItemProps> = ({ to, label, onClick }) => {
  const { pathname } = useLocation();

  return (
    <Menu.Item key={to} className={`menu-item ${pathname === to ? 'menu-link-active' : ''}`}>
      <Link to={to} className="menu-link" onClick={(e) => onClick?.(e, to)}>
        {label}
      </Link>
    </Menu.Item>
  );
};

export default MenuItem